import React, { PureComponent } from 'react';
import { Player, BigPlayButton, ControlBar, PlaybackRateMenuButton } from 'video-react';
import './fill.css';

export default class CustomVideoReact extends PureComponent {
  render() {
    // fill (optional): make the player fill its parent's height and letterbox
    // the video, instead of video-react's default fluid mode (height derived
    // from width, which overflows a fixed-height flex container). The parent
    // must have a definite height. Implemented via the `vr-fill` CSS class
    // (see fill.css) because video-react 0.16.0 has no `fill` prop.
    const { fill, player_ref, video_url, poster } = this.props;
    return (
      // player_ref (optional) exposes the video-react Player instance so
      // callers can drive playback (seek/play) — e.g. chapter chips.
      <Player
        playsInline
        fluid={!fill}
        className={fill ? 'vr-fill' : undefined}
        ref={player_ref}
        src={video_url}
        poster={poster}
      >
        <BigPlayButton position="center" />
        <ControlBar>
          <PlaybackRateMenuButton rates={[5, 2, 1, 0.5, 0.1]} />
        </ControlBar>
      </Player>
    );
  }
}
